import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { IS_JEST, DEV_MODE } from '../../utils/Constants';
import useAuthUtils from '../../utils/useAuthUtils';
import { faker } from '@faker-js/faker';
import Button from '../../components/controls/Button';
import { TextParagraph } from '../../components/controls/Typography/TextBody';
import { From } from '../../components/controls/Form';
import Heading from '../../components/controls/Typography/Heading';

import './extras.less';

export const SuccessDeclineWithAcc = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useAuthUtils();

  const { title = null, action = null, pdfDownloadLink = null } = location.state ?? (IS_JEST || DEV_MODE ? {
    title: faker.lorem.words(5),
    pdfDownloadLink: faker.internet.url(),
  } : {});

  useEffect(() => {
    document.title = 'Letters Portal - Guest Access';
    IS_JEST || DEV_MODE || title ? void 0 : navigate('/notFound');
  }, []);

  return (
    <main className="lsn-page lsn-page-success lsn-page-success-decline-with-acc">
      <Heading className="text-center no-focus-outline" tabIndex={0}>
        {title}
      </Heading>

      {pdfDownloadLink ? (
        <div className="lsn-download-btn text-center">
          <Button
            primary
            ghost
            icon={<i className="far fa-download"></i>}
            onClick={() => {
              window.open(pdfDownloadLink, '_blank');
            }}
          >
            Download a pdf
          </Button>
        </div>
      ) : null}

      <From
        title='Login to view previous or saved requests'
        classNameForm='guest-submission-container'
        isNarrow
        hasBorder
        isButtonsStack
        formAttr={{
          title: 'Login to view previous or saved requests'
        }}
        buttons={
          <>
            <Button
              primary
              onClick={() => auth.doLogin()}
            >
              Go to Log In
            </Button>

            <Button
              ghost
              onClick={() => auth.doLogout({
                onComplete: () => window.close()
              })}
            >
              No thanks, close this window.
            </Button>
          </>
        }
      >

        <TextParagraph>
          This request has been added to your <span> {action} </span> requests on your dashboard. You can view
          all <span> {action} </span> requests by logging in below.
        </TextParagraph>
      </From>

    </main>
  );
};

export default SuccessDeclineWithAcc;
